import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { useDashboardTFunction } from '@retail/dashboard/i18n';
import { Paper, TagHeading } from '@shared/components';

interface Props {
  userName: string;
  /** Rendered to the right of the greeting — e.g. the shared dashboard period picker. */
  action?: ReactNode;
}

export function WelcomeCard({ userName, action }: Props) {
  const t = useDashboardTFunction();
  return (
    <Paper sx={{ px: 3, py: 2 }}>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
      >
        <Stack direction="row">
          <TagHeading color="primary">
            <Typography variant="h4" component="h1" fontWeight={500}>
              {t('dashboard.welcome', { name: userName })}
            </Typography>
          </TagHeading>
        </Stack>
        {action && <div>{action}</div>}
      </Stack>
    </Paper>
  );
}
